export default class Taxation {
    constructor() {
        this.id = "";
        this.identificacao = "";
        this.codigo = "";
        this.codigoTributacao = "";
        this.nbs = "";
        this.cnae = "";
        this.aliquota = 0;
        this.discriminacao = "";
    }
    update(data) {
        this.id = data.id;
        this.identificacao = data.identificacao;
        this.codigo = data.codigo;
        this.codigoTributacao = data.codigoTributacao;
        this.nbs = data.nbs;
        this.cnae = data.cnae;
        this.aliquota = data.aliquota;
        this.discriminacao = data.discriminacao;
    }
}

